import Fit from "./Fit";

const Unfit = () => {
  return <Fit />;
};
export default Unfit;
